import { render } from "./TrafficAlertRuleDialog.vue?vue&type=template&id=68362e6c"
import script from "./TrafficAlertRuleDialog.vue?vue&type=script&lang=js"
export * from "./TrafficAlertRuleDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__